<template>
  <div ref="swiper" class="swiperSlider swiper-container">
    <div class="swiper-wrapper">
      <slot />
    </div>
    <slot name="pagination" />
  </div>
</template>

<script>
import Swiper, { Lazy, Navigation, Pagination, Autoplay } from 'swiper';

export default {
  name: 'SwiperSlider',
  props: {
    options: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      swiper: undefined,
    };
  },
  computed: {
    swiperOptions() {
      const options = { ...this.options };

      if (typeof options.lazy !== 'undefined') {
        options.modules = [...(options.modules ?? []), Lazy];
      }

      if (typeof options.navigation !== 'undefined') {
        options.modules = [...(options.modules ?? []), Navigation];
      }

      if (typeof options.autoplay !== 'undefined') {
        options.modules = [...(options.modules ?? []), Autoplay];
      }

      if (typeof options.pagination !== 'undefined') {
        options.modules = [...(options.modules ?? []), Pagination];
      }

      return options;
    },
  },
  mounted() {
    if (this.$refs.swiper) {
      this.swiper = new Swiper(this.$refs.swiper, this.swiperOptions);
    }
  },
  methods: {
    initSwiper() {
      this.swiper.init();
    },
  },
};
</script>

<style lang="scss" scoped>
.swiperSlider {
  overflow: hidden;
}
</style>
